/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Select } from '@leverege/ui-redux';
import { Flex, Checkbox, Button, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Rsrc from "./Rsrc.js";
const {
  t
} = I18N.ns('userManagement.Columns');
/**
 * @param {} targeted
 * @param {} targetedCount
 * @param {array} users
 * @param {function} onCheck
 * @param {function} onCheckAll
 * @param {function} onEdit
 */
function getColumns({
  targeted,
  targetedCount,
  users,
  postActionsToolbar,
  onCheck,
  onCheckAll,
  onResend,
  resent
}) {
  // This should be coming from a profile model.
  return [{
    id: 'targeted',
    maxWidth: 50,
    resizable: false,
    sortable: false,
    accessor: d => Select.isSelected(targeted, d.id),
    Header: () => {
      const selected = targetedCount !== 0 && targetedCount === users.length;
      return /*#__PURE__*/React.createElement(Flex, {
        variant: "rowS",
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        value: selected,
        onChange: onCheckAll
      }));
    },
    Cell: ({
      original,
      value
    }) => {
      return /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        eventData: original,
        value: value,
        onChange: onCheck
      }));
    }
  }, {
    Header: t('name'),
    sortable: false,
    id: 'name',
    accessor: item => {
      const {
        id,
        email,
        username,
        name,
        type
      } = item;
      if (type === 'apiAccess') {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-key fa-fw"
        }), " ", name);
      }
      // if ( username && name && name !== username ) {
      //   return <span>{name} <Text style={{display : 'inline-block'}} variant="username|hint">({username})</Text></span>
      // }
      return name || username || email || (id === 'anonymous' ? t('anonymous') : id === 'any' ? t('any') : id);
    }
  }, {
    Header: Rsrc.usernameColumnLabel,
    sortable: false,
    accessor: 'username'
  }, {
    Header: Rsrc.emailColumnLabel,
    sortable: false,
    accessor: 'email'
  }, {
    Header: t('phone'),
    sortable: false,
    accessor: 'phone'
  }, {
    Header: t('roles'),
    sortable: false,
    id: 'roles',
    accessor: item => {
      return item.roles.map(role => /*#__PURE__*/React.createElement(Text, {
        key: role.id
      }, role.displayName || role.name));
    }
  }, {
    id: 'lastAccessed',
    Header: t('lastAccessed'),
    sortable: false,
    accessor: item => {
      if (item.lastLogin) {
        return /*#__PURE__*/React.createElement(Text, null, new Date(item.lastLogin).toLocaleString().replace(',', ''));
      }
      if (item.type === 'apiAccess' || item.activated) {
        return '';
      }
      const didResend = resent[item.id];
      return /*#__PURE__*/React.createElement(Button, {
        variant: "resendInvite|secondarySmall",
        eventData: item,
        disabled: didResend,
        icon: didResend ? 'fa fa-check' : null,
        onClick: onResend
      }, didResend ? t('sent') : t('resend'));
    }
  },
  // {
  //   Header : 'Actions',
  //   sortable : false,
  //   id : 'actions',
  //   accessor : ( item ) => {
  //     if ( item.lastLogin ) {
  //       return null
  //     }

  //     const didResend = resent[item.id]

  //     return (
  //       <Button
  //         variant="resendInvite|secondarySmall"
  //         eventData={item}
  //         disabled={didResend}
  //         icon={didResend ? 'fa fa-check' : null}
  //         onClick={onResend}>
  //         {didResend ? 'Sent' : 'Resend Invite'}
  //       </Button>
  //     )
  //   }
  // },
  {
    Header: t('postActions'),
    id: 'postActionsToolbar',
    sortable: false,
    accessor: item => {
      return /*#__PURE__*/React.cloneElement(postActionsToolbar, {
        ...postActionsToolbar.props,
        context: {
          ...postActionsToolbar.props.context,
          item
        }
      });
    },
    maxWidth: 64
  }];
}
export { getColumns };